import type { Chain } from '../../chain';
import { CHAINS_INFO_MAP } from '../../wallets/constants';

export const getWaasChainNameFromChain = (chain: Chain): string => {
  return CHAINS_INFO_MAP[chain].waasChainNameOverride || chain;
};
